/* eslint-disable no-inline-styles/no-inline-styles */
import { useTheme } from "cayo.ui";
import React, { FC } from "react";
import styled from "styled-components";
import Icon from "./Icon";

const GearsIcon: FC = () => {
  const { cayoTheme } = useTheme();
  const iconColor = cayoTheme.brandColors.disabled;
  return (
    <div>
      <Icon
        style={{ fontWeight: 500, fontSize: "18px", color: iconColor }}
        rotateSpeed={"16s"}
        iconName="Settings"
        rotate={"true"}
        backward={true}
      ></Icon>
      <SecondIconWrapper>
        <Icon
          rotateSpeed={"16s"}
          style={{ fontSize: "30px", color: iconColor }}
          iconName="Settings"
          rotate={"true"}
        ></Icon>
      </SecondIconWrapper>
    </div>
  );
};

const SecondIconWrapper = styled.div`
  margin-top: -45px;
  margin-left: 14px;
`;

export default GearsIcon;
